import type { AuthSession } from './types';

export const isSuperuserSession = (session: AuthSession | null): boolean => {
  if (!session) {
    return false;
  }

  return (session.roles ?? []).includes('superuser') && session.superuserEmailMatched === true;
};

export const hasScopedAdminAccess = (
  session: AuthSession | null,
  organisationId: string | null | undefined,
): boolean => {
  if (!session || !organisationId) {
    return false;
  }

  return isSuperuserSession(session);
};
